document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('forgottenPaswordFrm');
    if (!form) return;

    var submit = document.getElementById('forgottenSubmit');
    var errorsEl = document.getElementById('forgottenErrors');
    var errorsList = document.getElementById('forgottenErrorsList');
    var completeEl = document.getElementById('forgottenComplete');

    function clearErrors() {
        if (errorsList) errorsList.innerHTML = '';
        if (errorsEl) errorsEl.style.display = 'none';
    }

    function showErrors(arr) {
        clearErrors();
        if (!arr || !arr.length) return;
        arr.forEach(function (e) {
            var li = document.createElement('li');
            li.textContent = e;
            errorsList.appendChild(li);
        });
        errorsEl.style.display = '';
    }

    if (submit) submit.addEventListener('click', function () {
        clearErrors();

        var memberInput = document.getElementById('forgottenMemberLogin');
        var memberVal = memberInput ? memberInput.value : '';

        var body = {
            MemberLogin: memberVal,
            ResetPasswordEmailID: form.dataset.resetPasswordEmailid || 0,
            ResetPasswordPageID: form.dataset.resetPasswordPageid || 0,
            PageMadeOn: form.dataset.pagemadeon || '',
            PageMadeOnUrl: form.dataset.pagemadeonurl || '',
            FormName: form.dataset.formName || ''
        };

        submit.disabled = true;
        submit.classList.add('disabled');

        fetch('/Umbraco/Api/MembershipApi/SendForgottenPassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then(function (resp) {
            return resp.json();
        }).then(function (data) {
            submit.disabled = false;
            submit.classList.remove('disabled');

            if (data && data.success) {
                form.style.display = 'none';
                if (completeEl) completeEl.style.display = '';

                // dataLayer push
                if (body.FormName) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({ event: 'formSubmission', formName: body.FormName });
                }

                // scroll to form
                var theForm = document.querySelector('.forgotten-password-form');
                if (theForm) {
                    window.scrollTo({ top: theForm.getBoundingClientRect().top + window.scrollY - 150, behavior: 'smooth' });
                }

            } else {
                var errs = (data && data.errors) ? data.errors : ['An issue occurred when attempting to send your request.'];
                showErrors(errs);
            }
        }).catch(function () {
            submit.disabled = false;
            submit.classList.remove('disabled');
            showErrors(['An issue occurred when attempting to send your request.']);
        });
    });
});


